module.exports = __webpack_public_path__ + "img/pay_bank_9.47b07264.png";